import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { addTabTitle, handleLocalStorage, returnSourceType, getFullscreenEnabled, routerJump } from '@/assets/js/utils.js';
import AgoraRTCClient from '@/assets/js/rtc-client-ng';
import i18n from '@/lang/index.js';
import { controlDeviceBehavior, controlAudio, controlDevicePublish } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
const nodeUrl = require('url');
export default {
  data() {
    return {
      anyWhereVideoAudioInfo: null,
      anywhereSettingShowMap: {},
      anywhereSettingShow: false,
      anyWhereInfo: {
        show: false,
        rtilCode: ''
      },
      deviceTypeMap: {},
      anyWherePlatForms: {},
      anyWhereSettings: {},
      anyWherePeerIds: {},
      showUnread: false,
      lowNetworkTime: 0,
      lowNetwork: false,
      initAudioOnlyPopup: true,
      dealTalkStreamHasUnsubscribe: false,
      dealSpeakStreamHasUnsubscribe: false,
      dealShareStreamHasUnsubscribe: false,
      questionerStream: {},
      getReceiverParams: '',
      getRListTimer: null,
      reloadComponent: true,
      batchMovePartyInfo: {
        show: false,
        rtilCodes: []
      },
      movePartyInfo: {
        show: false
      },
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      collaborateInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      degreeHost: {},
      movePips: {},
      rtilStatusTimer: null,
      rtilStatusObj: {},
      tabPosition: 'left',
      channels: {},
      raiseHandList: [],
      questionerList: [],
      questionerStreamMap: {},
      rtc: null,
      selectValue: '',
      partyCode: '',
      realPartyCode: '',
      rtilCode: '',
      wsPageSTimer: null,
      setTimer: null,
      joinParam: null,
      speakStream: {},
      talkStream: {},
      MeInfo: {},
      setNameInfo: {
        show: false
      },
      userInfo: {},
      nickNameInfo: {},
      showStartTalkButton: false,
      replaceInfo: null,
      privateStream: {},
      shareStream: {},
      showShareScreen: false,
      allScreen: false,
      shareInfo: null,
      setLoading: false,
      sendRaiseHandParams: {
        pageNum: 1,
        pageSize: 14
      },
      sourceIds: [],
      allRList: [],
      sourceTIds: [],
      allAccountIdByRtilCode: {},
      showLocalRenameInput: false,
      editNameVal: '',
      showLocalVideo: false,
      allPartyMembers: [],
      mainWindowList: [],
      mainWindowType: '',
      selectRId: '',
      outPutRtilCode: '',
      sourceSelect: '',
      tabVal: '',
      muteBtnActive: false,
      tagNameInfo: {},
      setTagName: {
        show: false,
        tagName: ''
      },
      tipInfo: {
        title: 'Note',
        content: '<div class="end">When the live stream starts, <p>In case Interviewer is replaced, receiver will keep live with the new Interviewer.</p></div>',
        cancel: 'Cancel',
        save: 'Done',
        show: false
      },
      organizationInfo: {},
      encoderInfo: {
        visible: false,
        data: [],
        maxNumber: 1
      },
      devicesInfo: {},
      showSpeakerFullScreen: false,
      showTalkFullScreen: false,
      showShareFullScreen: false,
      mainWindowSelectList: [{
        label: 'Source type',
        options: [{
          value: 'VFB',
          label: 'VFB (Receiver Video Return)'
        }, {
          value: 'PP',
          label: 'PP (Producer)'
        }, {
          value: 'pip',
          label: 'Speaker (Participants)'
        }]
      }],
      outputSourceType: '',
      loadChatBox: true,
      loadRaiseHand: false,
      loadAudience: false,
      hadOpenWebCloud: false,
      showAudience: false,
      shareRtilCode: '',
      shareClient: null,
      isAudioLevel: false,
      voiceList: {},
      hasGetTimeOffset: false,
      bestOffset: 0,
      sendMetadataTimer: null
    };
  },
  created() {
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach((volume, index) => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$on('setPartyTitle', v => {
      document.title = this.$t('common.partyTitle', {
        name: v.title
      });
    });
    Bus.$on('changeRaiseHand', v => {
      this.loadRaiseHand = v;
    });
    Bus.$on('changeAudience', v => {
      this.loadAudience = v;
    });
    Bus.$on('initDevices', obj => {
      this.devicesInfo.cameraId = obj.selectCameraId;
      this.devicesInfo.cameraList = obj.videoList;
      this.devicesInfo.microphoneId = obj.selectMicroId;
      this.devicesInfo.microphoneList = obj.microList;
    });
    // end party
    Bus.$on('endParty', v => {
      if (this.$refs.asideRight) {
        this.$refs.asideRight.clickTab({
          name: 'close'
        });
      }
      this.setDefaultConfig();
      this.muteBtnActive = false;
      routerJump('remove', {
        type: 'end'
      });
    });
    Bus.$on('selectAllPipMove', v => {
      // 只对目前已有的与会者进行操作，后加入的不处理
      if (v.type == 'all') {
        this.State.batchMoveParticipateList.forEach(id => {
          if (this.shareRtilCode != id) {
            this.$set(this.movePips, id, v.status);
            this.attendCallback({
              type: 'moveParty',
              id: id,
              status: v.status,
              sign: 'batch'
            });
          }
        });
      }
    });
    Bus.$on('changePartyAddress', v => {
      // this.userInfo = {}
      this.setDefaultConfig('notChange');
      this.muteBtnActive = false;
    });
    Bus.$on('setSpeaker', v => {
      this.State.speakerInfo = v;
      this.userInfo.status.speaker = v.rtilCode;
      this.State.batchMoveParticipateList = this.State.batchMoveParticipateList.filter(val => val != parseInt(v.rtilCode));
      this.$set(this.movePips, v.rtilCode, false);
      if (v.rtilCode == this.rtilCode) {
        if (this.State.cameraStatus[this.rtilCode]) this.rtc.setEnabled(true, 'video');
        if (this.rtc && this.State.micStatus[v.rtilCode]) {
          if (this.rtc._localAudioTrack) {
            controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, true, result => {});
          }
        }
      }
      this.mainWindowType = 'Speaker';
    });
    Bus.$on('cancelSpeaker', v => {
      if (v.rtilCode == this.rtilCode) {
        var _this$rtc;
        this.rtc.setEnabled(false, 'video');
        ((_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : _this$rtc._localAudioTrack) && controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
        this.showLocalVideo = false;
        this.shareRtilCode = '';
        this.stopShare({
          id: this.shareRtilCode
        }, 'byClickShareIcon');
      }
      if (this.shareInfo && this.shareInfo.initiator == v.rtilCode) {
        this.shareInfo = null;
      }
      this.mainWindowType = '';
      this.State.speakerInfo = null;
      this.userInfo.status.speaker = '';
      this.speakStream = {};
      this.showSpeakerFullScreen = false;
      if (!v.notCancelSelectName) {
        this.selectValue = '';
      }
    });
    Bus.$on('questionerList', v => {
      this.questionerList = v.questionerList || [];
    });
    Bus.$on('setQuestioner', v => {
      // 判断是否是设置自己为questioner
      const isHost = v.rtilCode == this.rtilCode;
      if (isHost) {
        this.State.showConferenceLocal = true;
        if (this.State.cameraStatus[this.rtilCode]) this.rtc.setEnabled(true, 'video');
        if (this.State.micStatus[this.rtilCode] && this.rtc) {
          if (this.rtc._localAudioTrack) {
            controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, true, result => {});
          }
        }
      }
    });
    Bus.$on('cancelQuestioner', v => {
      if (this.rtilStatusObj[v.rtilCode] && this.rtilStatusObj[v.rtilCode].peerId && this.$refs[`source${v.rtilCode}`][0] && this.$refs[`source${v.rtilCode}`][0].$refs[`liveSource${v.rtilCode}`]) {
        this.$refs[`source${v.rtilCode}`][0].$refs[`liveSource${v.rtilCode}`].startOrStop();
      }
      const _this = this;
      if (v.rtilCode == this.rtilCode) {
        if (_this.State.privateInfo && _this.State.privateInfo.crewRtilCode == v.rtilCode) {
          this.rtc.setEnabled(false, 'video');
        } else {
          var _this$rtc2;
          this.rtc.setEnabled(false, 'video');
          ((_this$rtc2 = this.rtc) === null || _this$rtc2 === void 0 ? void 0 : _this$rtc2._localAudioTrack) && controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
        }
        this.State.showConferenceLocal = false;
      }
    });
    const _this = this;
    Bus.$on('startPrivateConversation', v => {
      this.State.privateInfo = v;
      if (this.rtc && this.State.micStatus[this.rtilCode]) {
        if (this.rtc._localAudioTrack) {
          controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
        } else {
          // 初始化的时候没有本地音频轨道，需要重新获取
          controlAudio(this.rtc, this.devicesInfo, true, result => {});
        }
      }
    });
    Bus.$on('cancelPrivateConversation', v => {
      this.State.privateInfo = {};
      this.privateStream = {};
      const talkInfo = this.State.talkInfo;
      const speakerInfo = this.State.speakerInfo;
      if (this.rtc && (!talkInfo && !speakerInfo || talkInfo && talkInfo.rtilCode != this.rtilCode || speakerInfo && speakerInfo.rtilCode != this.rtilCode)) {
        controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
      }
    });
    Bus.$on('setQuestionSpeaker', async v => {
      this.dealSubscribeVideo({
        id: v.rtilCode
      });
      if (v.rtilCode == this.rtilCode) {
        this.State.showConferenceLocal = true;
      }
      this.State.talkInfo = v;
      this.State.batchMoveParticipateList = this.State.batchMoveParticipateList.filter(val => val != parseInt(v.rtilCode));
      this.$set(this.movePips, v.rtilCode, false);
      this.userInfo.status.questionSpeaker = v.rtilCode;
      if (this.showStartTalkButton && !v.notNeedDelete) {
        if (v.index - 1 == 0) {
          this.questionerList.splice(v.index - 1, 1);
        } else {
          // 当在快捷模式下想和其他人进行talk要先移除掉第一位然后在此基础上在移除掉当前的
          await this.removeQuestioner();
          this.questionerList.splice(0, 1);
          this.questionerList.splice(v.index - 2, 1);
        }
        this.showStartTalkButton = false;
      } else {
        if (!v.deleteIndex) {
          this.questionerList.splice(v.index, 1);
        }
        this.showStartTalkButton = false;
      }
      if (v.rtilCode == this.userInfo.rtilCode) {
        var _this$rtc3;
        if (this.State.micStatus[v.rtilCode] && (_this$rtc3 = this.rtc) !== null && _this$rtc3 !== void 0 && _this$rtc3._localAudioTrack) {
          controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
        }
        if (this.State.cameraStatus[v.rtilCode]) this.rtc.setEnabled(true, 'video');
      }
    });
    Bus.$on('cancelQuestionSpeaker', v => {
      this.showTalkFullScreen = false;
      // 用来清除之前把host设置成questioner的状态
      if (v.rtilCode == this.rtilCode) {
        this.State.showConferenceLocal = false;
      }
      // 需要检测是否有下一个有的话自动检测并且记录下一个信息
      if (v.showStartButton && this.questionerList.length) {
        this.replaceInfo = {
          ...this.questionerList[0],
          index: 0
        };
        this.showStartTalkButton = true;
      }
      if (v.rtilCode == this.rtilCode) {
        if (_this.State.privateInfo && _this.State.privateInfo.crewRtilCode == v.rtilCode) {
          this.rtc.setEnabled(false, 'video');
        } else {
          var _this$rtc4;
          this.rtc.setEnabled(false, 'video');
          ((_this$rtc4 = this.rtc) === null || _this$rtc4 === void 0 ? void 0 : _this$rtc4._localAudioTrack) && controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
        }
      }
      this.State.talkInfo = null;
      this.userInfo.status.questionSpeaker = '';
      this.talkStream = {};
    });
    Bus.$on('online', v => {
      const {
        role
      } = v;
      // report list
      if (role === 2) {
        this.$refs.audience && this.$refs.audience.changeAudience(v, 'add');
      }
      let btn = true;
      // 保证没有重复的
      this.allPartyMembers.forEach(rtilCode => {
        if (rtilCode == v.rtilCode) btn = false;
      });
      if (btn) this.allPartyMembers.push(v.rtilCode);
    });
    Bus.$on('offline', v => {
      const {
        role
      } = v;
      if (role === 2) {
        this.$refs.audience && this.$refs.audience.changeAudience(v, 'delete');
      }
      this.allPartyMembers.forEach((rtilCode, index) => {
        if (v.rtilCode == rtilCode) {
          this.allPartyMembers.splice(index, 1);
        }
      });
    });
    Bus.$on('shareScreen', v => {
      this.shareInfo = JSON.parse(v.shareMsg);
    });
    Bus.$on('cancelScreen', v => {
      this.shareInfo = null;
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.nickNameInfo, val.mark, val.value);
          if (this.shareInfo && val.mark == this.shareInfo.initiator) {
            this.shareInfo.nickName = val.value;
          }
          if (this.State.talkInfo && val.mark == this.State.talkInfo.rtilCode) {
            this.State.talkInfo.nickName = val.value;
          }
          if (this.State.speakerInfo && val.mark == this.State.speakerInfo.rtilCode) {
            this.State.speakerInfo.nickName = val.value;
          }
          if (val.mark == this.rtilCode) {
            this.userInfo.behavior.nickName = val.value;
          }
          this.questionerList.forEach(inVal => {
            if (inVal.rtilCode == val.mark) {
              inVal.nickName = val.value;
            }
          });
        } else if (val.key === 'organization') {
          this.$set(this.organizationInfo, val.mark, val.value);
          if (this.State.talkInfo && val.mark == this.State.talkInfo.rtilCode) {
            this.State.talkInfo.organization = val.value;
          }
          if (this.State.speakerInfo && val.mark == this.State.speakerInfo.rtilCode) {
            this.State.speakerInfo.organization = val.value;
          }
          this.questionerList.forEach(inVal => {
            if (inVal.rtilCode == val.mark) {
              inVal.organization = val.value;
            }
          });
        }
        if (val.key == 'tagName') {
          this.$set(this.tagNameInfo, val.mark, val.value);
        }
        if (val.key === 'mic') {
          if (val.mark == this.userInfo.rtilCode) {
            this.$set(this.State.micStatus, val.mark, val.value !== 'false');
          }
        }
        if (val.key === 'camera') {
          if (val.mark == this.userInfo.rtilCode) {
            this.$set(this.State.cameraStatus, val.mark, val.value !== 'false');
          }
        }
        if (this.anyWhereSettings[val.mark] && val.key in this.anyWhereSettings[val.mark]) {
          if (val.key === 'whiteBalance') {
            const parsedValue = JSON.parse(val.value);
            this.$set(this.anyWhereSettings[val.mark], val.key, parsedValue);
          } else {
            // Directly set the value for other keys
            this.$set(this.anyWhereSettings[val.mark], val.key, val.value);
          }
        }
      });
    });
    Bus.$on('setOutput', v => {
      this.outPutRtilCode = v.rtilCode;
      this.outputSourceType = v.sourceType;
      if (this.rtc._remotePublishUser[v.rtilCode]) {
        const {
          videoTrack,
          audioTrack
        } = this.rtc._remotePublishUser[v.rtilCode];
        const obj = {};
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        obj.id = v.rtilCode;
        obj.rtilCode = v.rtilCode;
        obj.channel = this.userInfo.realPartyCode;
        if (v.rtilCode == this.userInfo.rtilCode) obj.showLocal = true;
        this.speakStream = obj;
      }
    });
    Bus.$on('cancelOutput', () => {
      this.outputSourceType = '';
      this.outPutRtilCode = '';
      if (this.speakStream && this.speakStream.id == this.userInfo.rtilCode) {
        var _this$rtc5;
        if ((_this$rtc5 = this.rtc) !== null && _this$rtc5 !== void 0 && _this$rtc5._localAudioTrack) {
          controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
        }
        this.speakStream.videoTrack && this.rtc.setEnabled(false, 'video');
      }
      this.State.speakerInfo = null;
      this.speakStream = {};
    });
    this.getMainWindowList();

    // 获取rtil对应的R的状态
    Bus.$off('pageSerBusCallback');
    Bus.$on('pageSerBusCallback', v => {
      if (v.partyCode != this.partyCode) return;
      this.pageSerBusCallback(v);
    });
    Bus.$on('rtilLiveStatus', v => {
      this.rtilStatusObj = v;
    });
    Bus.$on('notify', v => {
      const {
        key,
        rtilCode
      } = v;
      if (key === 'micCamera') {
        this.$set(this.State.cameraStatus, rtilCode, false);
        this.$message.warning(this.$t('kioskHost.requestDeny'));
      }
    });
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status,
        toEmail
      } = result;
      if (collaborateUserId == this.State.loginInfo.id) {
        status === 0 ? this.collaborateInfo.show = true : this.collaborateInfo.show = false;
        if (status === 0) {
          this.collaborateInfo.info = result;
        } else if (status === 2) {
          this.collaborateInfo.info = {};
        }
      } else {
        if (status === 1) {
          this.$message.success(toEmail + this.$t('personalInfo.accepted'));
        } else if (status === 2) {
          this.$message.warning(toEmail + this.$t('personalInfo.refuseInvite'));
        }
      }
    });
    Bus.$on('setLoginScreenButton', async val => {
      const _this = this;
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 7) {
        if (operationType) {
          this.hadOpenWebCloud = true;
          if (this.rtc) await this.rtc.leave();
          _this.userInfo.status.cloudProxy = 1;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam);
        } else {
          this.hadOpenWebCloud = false;
          if (this.rtc) await this.rtc.leave('closeCLoudProxy');
          _this.userInfo.status.cloudProxy = 0;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam);
        }
      } else if (buttonType === 17) {
        if (operationType === 0) {
          this.isAudioLevel = true;
        } else {
          this.isAudioLevel = false;
        }
      }
    });
    Bus.$on('flipVideo', v => {
      // 与会者getList(与会者、anywhere)
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    // audioOnly选择器
    Bus.$on('subscribeAudioControl', val => {
      this.dealSpeakStreamHasUnsubscribe = false;
      this.dealTalkStreamHasUnsubscribe = false;
      this.dealShareStreamHasUnsubscribe = false;
      if (val) {
        // 2 禁用
        if (val == 2) {
          // 主讲人
          if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.hasUnsubscribe && this.speakStream) {
            this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
            this.speakStream.hasUnsubscribe = false;
          }
          if (this.talkStream.id != this.userInfo.rtilCode && this.talkStream.hasUnsubscribe && this.talkStream) {
            // 提问者
            this.rtc.subscribe(this.talkStream.id, 'video', 'unExecuteCallback');
            this.talkStream.hasUnsubscribe = false;
          }
          // 采访者队列
          Object.keys(this.questionerStream).forEach(id => {
            if (this.questionerStream[id].id) {
              this.rtc.subscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
              this.questionerStream[id].hasUnsubscribe = false;
            }
          });
          if (this.shareStream.id != this.userInfo.rtilCode && this.shareStream.id && this.shareStream.hasUnsubscribe) {
            // 分享屏幕
            if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
            this.shareStream.hasUnsubscribe = false;
          }
          return; // 2 是关闭 audio-only 状态不用订阅
        }
        // 1 allTheTime
        // 主讲人
        if (this.outPutRtilCode == this.speakStream.id && this.speakStream.id != this.userInfo.rtilCode && !this.speakStream.hasUnsubscribe && this.speakStream.id) {
          // 需要判断当前的 mainWindow是否处于选中状态，选中需要订阅
          if (!this.State.checkMainWindow) {
            this.rtc.unsubscribe(this.speakStream.id, 'video', 'unExecuteCallback');
            this.speakStream.hasUnsubscribe = true;
          }
        }
        if (this.outPutRtilCode != this.talkStream.id && this.talkStream.id != this.userInfo.rtilCode && !this.talkStream.hasUnsubscribe && this.talkStream.id) {
          // 提问者
          this.rtc.unsubscribe(this.talkStream.id, 'video', 'unExecuteCallback');
          this.talkStream.hasUnsubscribe = true;
        }
        if (this.shareStream.id != this.userInfo.rtilCode && this.shareStream.id && !this.shareStream.hasUnsubscribe) {
          // 分享屏幕
          if (!this.State.checkShareScreen && !this.State.localShareInfo[this.shareStream.id]) {
            this.rtc.unsubscribe(this.shareStream.id, 'video', 'unExecuteCallback');
            this.shareStream.hasUnsubscribe = true;
          }
        }
        // 采访者队列
        Object.keys(this.questionerStream).forEach(id => {
          if (this.questionerStream[id].id) {
            this.rtc.unsubscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
            this.questionerStream[id].hasUnsubscribe = true;
          }
        });
      } else {
        // 0 自动
        // 主讲人
        if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.hasUnsubscribe && this.speakStream) {
          // 需要判断当前的 mainWindow是否处于选中状态，选中需要订阅
          // 分为两种情况一种网络较好(可以不取参考checkbox)，另外一种是网络不好需要参考checkbox
          if (!this.State.inAudioOnlyStatus) {
            this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
            this.speakStream.hasUnsubscribe = false;
          } else {
            if (this.State.checkMainWindow) {
              this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
              this.speakStream.hasUnsubscribe = false;
            }
          }
        }
        if (this.talkStream.id != this.userInfo.rtilCode && this.talkStream.hasUnsubscribe && this.talkStream) {
          // 提问者
          if (!this.State.inAudioOnlyStatus) {
            this.rtc.subscribe(this.talkStream.id, 'video', 'unExecuteCallback');
            this.talkStream.hasUnsubscribe = false;
          } else {
            this.rtc.subscribe(this.talkStream.id, 'video', 'unExecuteCallback');
            this.talkStream.hasUnsubscribe = false;
          }
        }
        if (this.shareStream.id != this.userInfo.rtilCode && this.shareStream.hasUnsubscribe && this.shareStream) {
          // 分享屏幕
          if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
          this.shareStream.hasUnsubscribe = false;
        }
        // 采访者队列
        Object.keys(this.questionerStream).forEach(id => {
          if (this.questionerStream[id].id) {
            this.rtc.subscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
            this.questionerStream[id].hasUnsubscribe = false;
          }
        });
      }
    });
    // mainWindow 勾选
    Bus.$on('dealMainAudioOnly', val => {
      if (this.outPutRtilCode || this.talkStream) {
        // 先判断当前处于哪种模式下
        if (this.State.audioType) {
          // 2
          if (this.State.audioType == 2) {
            if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id) {
              this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
              this.speakStream.hasUnsubscribe = false;
              this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
            }
          } else {
            // 1
            if (val) {
              if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id) {
                this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
                this.speakStream.hasUnsubscribe = false;
                this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
              }
            } else {
              if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id) {
                this.rtc.unsubscribe(this.speakStream.id, 'video', 'unExecuteCallback');
                this.speakStream.hasUnsubscribe = true;
                this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
              }
            }
          }
          // 0
        } else {
          // 如果是 auto audio-only 需要先判断当前是否处于 audio-only 状态中
          if (!this.State.inAudioOnlyStatus) {
            if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id) {
              this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
              this.speakStream.hasUnsubscribe = false;
              this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
            }
          } else {
            if (val) {
              if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id) {
                this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
                this.speakStream.hasUnsubscribe = false;
                this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
              }
            } else {
              if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id) {
                this.rtc.unsubscribe(this.speakStream.id, 'video', 'unExecuteCallback');
                this.speakStream.hasUnsubscribe = true;
                this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
              }
            }
          }
        }
      }
    });
    // shareScreen 勾选
    Bus.$on('dealShareAudioOnly', val => {
      if (this.shareStream.id != this.userInfo.rtilCode && this.shareStream.id) {
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
            this.shareStream.hasUnsubscribe = false;
            this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
          } else {
            if (val) {
              if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
              this.shareStream.hasUnsubscribe = false;
              this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
            } else {
              if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.unsubscribe(this.shareStream.id, 'video', 'unExecuteCallback');
              this.shareStream.hasUnsubscribe = true;
              this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
            }
          }
        } else {
          if (!this.State.inAudioOnlyStatus) {
            if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
            this.shareStream.hasUnsubscribe = false;
            this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
          } else {
            if (val) {
              if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
              this.shareStream.hasUnsubscribe = false;
              this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
            } else {
              if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.unsubscribe(this.shareStream.id, 'video', 'unExecuteCallback');
              this.shareStream.hasUnsubscribe = true;
              this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
            }
          }
        }
      }
    });
    // audioOnly自动网络质量变化的情况下
    Bus.$on('downlinkNetworkQuality', val => {
      // 判断当前所选择的 audio-only 模式，如果是 all time 的话则不需要走这段逻辑
      if (this.State.audioType || this.State.audioType == 2) return;
      // 当连续8s处于若网时，则改为只订阅音频流,连续6s状态良好则恢复订阅视频流
      if (val < 4) {
        if (this.lowNetworkTime > 0) {
          this.lowNetworkTime--;
        } else {
          this.lowNetworkTime = 0;
        }
        if (this.lowNetwork && this.lowNetworkTime === 0) {
          this.lowNetwork = false;
          if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id && this.speakStream.hasUnsubscribe) {
            this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
            this.speakStream.hasUnsubscribe = false;
            this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
          }
          if (this.talkStream.id != this.userInfo.rtilCode && this.talkStream.id && this.talkStream.hasUnsubscribe) {
            // 提问者
            this.rtc.subscribe(this.talkStream.id, 'video', 'unExecuteCallback');
            this.talkStream.hasUnsubscribe = false;
            this.dealTalkStreamHasUnsubscribe = this.talkStream.hasUnsubscribe;
          }
          // 采访者队列
          Object.keys(this.questionerStream).forEach(id => {
            if (this.questionerStream[id].id) {
              this.rtc.subscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
              this.questionerStream[id].hasUnsubscribe = false;
            }
          });
          if (this.shareStream.id != this.userInfo.rtilCode && this.shareStream.id && this.shareStream.hasUnsubscribe) {
            // 分享屏幕
            if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
            this.shareStream.hasUnsubscribe = false;
            this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
          }
          this.State.inAudioOnlyStatus = false;
          this.initAudioOnlyPopup = true;
        }
      } else {
        if (this.lowNetworkTime < 3) {
          this.lowNetworkTime++;
        } else if (this.lowNetworkTime === 3) {
          this.lowNetwork = true;
        }
        if (this.lowNetwork) {
          if (!this.State.checkMainWindow && this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id && !this.speakStream.hasUnsubscribe) {
            this.rtc.unsubscribe(this.speakStream.id, 'video', 'unExecuteCallback');
            this.speakStream.hasUnsubscribe = true;
            this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
          }
          if (this.talkStream.id != this.userInfo.rtilCode && this.talkStream.id && !this.talkStream.hasUnsubscribe) {
            this.rtc.unsubscribe(this.talkStream.id, 'video', 'unExecuteCallback');
            this.talkStream.hasUnsubscribe = true;
            this.dealTalkStreamHasUnsubscribe = this.talkStream.hasUnsubscribe;
          }
          if (!this.State.checkShareScreen && this.shareStream.id != this.userInfo.rtilCode && this.shareStream.id && !this.shareStream.hasUnsubscribe) {
            // 分享屏幕
            if (!this.State.localShareInfo[this.shareStream.id]) this.rtc.unsubscribe(this.shareStream.id, 'video', 'unExecuteCallback');
            this.shareStream.hasUnsubscribe = true;
            this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
          }
          // 采访者队列
          Object.keys(this.questionerStream).forEach(id => {
            if (this.questionerStream[id].id) {
              this.rtc.unsubscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
              this.questionerStream[id].hasUnsubscribe = true;
            }
          });
          this.State.inAudioOnlyStatus = true;
          if (this.initAudioOnlyPopup) {
            this.initAudioOnlyPopup = false;
            this.$message.success(this.$t('netWorkStatus.poorNetworkPopup'));
          }
        }
      }
    });
    Bus.$on('controlBehavior', v => {
      const {
        rtilCode,
        behavior
      } = v;
      const {
        key,
        value
      } = behavior;
      if (key == 'nickName') {
        this.questionerList.forEach(inVal => {
          if (inVal.rtilCode == rtilCode) {
            inVal.nickName = value;
          }
        });
      }
    });
  },
  computed: {
    ...mapState({
      State: state => state,
      loginInfo: state => state.loginInfo,
      currentPartyInfo: state => state.currentPartyInfo,
      PrivateInfo: state => state.privateInfo,
      ChannelMode: state => state.channelMode
    }),
    judgeShowTitle() {
      if (!this.State.speakerInfo) {
        return false;
      } else {
        return this.outputSourceType == 'Participant';
      }
    },
    shareNickname() {
      let nickName = '';
      if (this.shareInfo) {
        nickName = this.shareInfo.nickName;
      }
      return nickName;
    },
    shareTitle() {
      let _str = '';
      if (this.shareInfo) {
        _str = this.shareInfo.rtilCode + '';
      }
      return _str;
    },
    talkOperate() {
      let array = [];
      if (this.State.talkInfo) {
        if (this.State.talkInfo.rtilCode == this.userInfo.rtilCode) {
          array = ['fullScreen', 'rename', 'hangUpInterview'];
        } else {
          if (this.State.talkInfo.rtilCode == this.State.privateInfo.rtilCode) {
            array = ['fullScreen', 'rename', 'editTagName', 'cancelPrivateConversation', 'hangUpInterview'];
          } else {
            array = ['fullScreen', 'rename', 'editTagName', 'startPrivateConversation', 'hangUpInterview'];
          }
        }
        // 移除anyWhere中的setting
        if (this.deviceTypeMap[this.State.talkInfo.rtilCode] == 'Anywhere' || this.deviceTypeMap[this.State.talkInfo.rtilCode] == 'App') {
          array.push('anyWhereSetting');
        }
      }
      return array;
    },
    speakerOperateList() {
      let array = [];
      if (this.showLocalVideo || this.outputSourceType != 'Participant') return array;
      if (this.State.speakerInfo) {
        if (this.State.speakerInfo.rtilCode == this.State.privateInfo.rtilCode) {
          array = ['editTagName', 'cancelPrivateConversation'];
        } else {
          array = ['editTagName', 'startPrivateConversation'];
        }
        array.unshift('rename');
        array.unshift('fullScreen');
      }
      return array;
    },
    returnRoleList() {
      let array = ['setSpeaker', 'cancelSpeaker'];
      if (this.mainWindowType != 'Speaker') {
        array = [];
      }
      return array;
    },
    isLocal() {
      let flag = false;
      if (this.State.talkInfo && this.State.talkInfo.rtilCode == this.userInfo.rtilCode) {
        flag = true;
      }
      return flag;
    },
    footList() {
      if (this.State.speakerInfo && this.State.speakerInfo.rtilCode == this.userInfo.rtilCode) {
        return ['camera', 'mic', 'speaker', 'share', 'chat'];
      } else {
        return ['camera', 'mic', 'speaker', 'chat'];
      }
    }
  },
  watch: {
    'currentPartyInfo.code': function (newVal, oldVal) {
      if (oldVal) {
        this.State.pageSerBusRequestWs[oldVal] && this.State.pageSerBusRequestWs[oldVal].close();
        this.$delete(this.State.pageSerBusRequestWs, oldVal);
        this.State.showConferenceLocal = false;
        this.showLocalVideo = false;
        this.selectValue = '';
      }
      this.initJoinFn(newVal);
    },
    'State.batchMoveParticipate': function (val) {
      this.batchMovePartyInfo.show = val;
      if (!val) {
        this.batchMovePartyInfo.rtilCodes = [];
        this.movePips = {};
      }
    },
    'State.speakerInfo': function (newVal) {
      if (!newVal) return;
      const {
        rtilCode
      } = newVal;
      // 设置自己为speaker
      if (rtilCode == this.rtilCode) {
        this.showLocalVideo = true;
      }
      this.speakStream.id = newVal.rtilCode;
      if (this.rtc._remotePublishUser[rtilCode]) {
        const {
          videoTrack,
          audioTrack
        } = this.rtc._remotePublishUser[rtilCode];
        const obj = {};
        obj.id = rtilCode;
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        obj.channel = this.userInfo.realPartyCode;
        if (newVal.rtilCode == this.userInfo.rtilCode) obj.showLocal = true;
        this.speakStream = obj;
      }
    },
    'State.talkInfo': function (newVal, oldVal) {
      if (!newVal) return;
      const {
        rtilCode
      } = newVal;
      this.talkStream.id = newVal.rtilCode;
      const obj = {};
      if (!this.rtc._remotePublishUser[rtilCode] && !this.channels[rtilCode]) return;
      let videoTrack = {};
      let audioTrack = {};
      if (this.rtc._remotePublishUser[rtilCode]) {
        videoTrack = this.rtc._remotePublishUser[rtilCode].videoTrack;
        audioTrack = this.rtc._remotePublishUser[rtilCode].audioTrack;
      }
      if (this.channels[rtilCode]) {
        videoTrack = this.channels[rtilCode].videoTrack;
        audioTrack = this.channels[rtilCode].audioTrack;
      }
      obj.id = newVal.rtilCode;
      // rtc-client-ng 里面关于删除 _remotePublishUser 代码逻辑有问题，这里用 channel 是为了兼容
      if (this.rtc._remotePublishUser[rtilCode] || this.channels[rtilCode]) {
        obj.id = rtilCode;
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        obj.showLocal = true;
        obj.channel = this.userInfo.realPartyCode;
        this.talkStream = obj;
      } else if (newVal.rtilCode == this.rtilCode) {
        if (!this.talkStream.id) {
          obj.videoTrack = videoTrack;
          obj.audioTrack = audioTrack;
          obj.showLocal = true;
          obj.channel = this.userInfo.realPartyCode;
          this.talkStream = obj;
        }
      }
    },
    shareInfo: {
      deep: true,
      handler: function (v) {
        if (!v) return;
        const {
          rtilCode
        } = v;
        if (this.rtc._remotePublishUser[rtilCode]) {
          const {
            videoTrack,
            audioTrack
          } = this.rtc._remotePublishUser[rtilCode];
          const obj = {};
          obj.id = rtilCode;
          obj.videoTrack = videoTrack;
          obj.audioTrack = audioTrack;
          this.shareStream = obj;
        }
      }
    },
    replaceInfo: {
      deep: true,
      handler: function (v) {
        if (!v) return;
        const {
          rtilCode
        } = v;
        if (this.rtc.remoteAllStream[rtilCode]) {
          const obj = {};
          obj.id = v.rtilCode;
          obj.remoteStream = this.rtc.remoteAllStream[rtilCode];
          this.talkStream = obj;
        }
      }
    }
  },
  filters: {
    showItemName: itemName => {
      if (!itemName) return '';
      if (itemName === 'None') {
        return i18n.t('conferenceHost.None');
      } else if (itemName === 'Speaker') {
        return i18n.t('conferenceHost.Speaker');
      } else if (itemName === 'Producer PGM') {
        return i18n.t('conferenceHost.producerPgm');
      } else if (itemName === 'VideoFeedBack') {
        return i18n.t('conferenceHost.VideoFeedBack');
      } else {
        return itemName;
      }
    }
  },
  mounted() {
    /**
     * @params 重构新加代码开始
     */
    const URL = nodeUrl.parse(location.href, true);
    if (URL.query.id) {
      // 检查 partyCode 中是否包含字母
      const hasLetters = /[a-zA-Z]/.test(URL.query.id);
      const illegalPartyCode = hasLetters ? URL.query.id : '';
      URL.query.id = URL.query.id.replace(/[^0-9]/ig, ''); // 过滤掉非数字字符
      if (URL.query.id.length > 20 || URL.query.id.length < 9) {
        this.$message.error(this.$t('common.invalidPartyIdText'));
        return;
      }
      this.getPartyInfo(URL.query.id, illegalPartyCode);
    }
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
    /**
     * @params 重构新加代码结束
     */
    // 获取sourceList
    this.getReceiverList();
  },
  methods: {
    closeAnywherePreview() {
      // 恢复的列表对象赋值给channels
      if (this.State.talkInfo && this.State.talkInfo.rtilCode == this.anyWhereInfo.rtilCode) {
        this.talkStream = this.anyWhereRtilCodeObj;
        this.anywhereSettingShow = false;
      } else {
        this.$set(this.questionerStreamMap, this.anyWhereInfo.rtilCode, this.anyWhereRtilCodeObj);
        this.$set(this.anywhereSettingShowMap, this.anyWhereInfo.rtilCode, false);
      }
      this.anyWhereInfo.rtilCode = '';
      this.anyWhereVideoAudioInfo = null;
    },
    // 处理初始化及其他 audio-only 时的视频订阅问题
    async dealSubscribeVideo(payload) {
      if (payload.id == this.userInfo.rtilCode || !payload.id) return;
      try {
        const {
          data: res
        } = await this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`);
        if (res.errorCode == '0x0') {
          const result = res.result;
          const accountId = result.accountId.toLowerCase();
          const {
            videoTrack,
            audioTrack
          } = payload;
          const channelInfo = {
            ...payload,
            tid: accountId,
            info: {
              rtilCode: payload.id
            },
            videoTrack,
            audioTrack,
            shareCode: accountId.indexOf('_sharescreen') > -1 ? payload.id : ''
          };
          const type = returnSourceType(result);
          this.$set(this.deviceTypeMap, payload.id, type);
          this.$set(this.State.deviceTypeMap, payload.id, type);
          this.$set(this.channels, payload.id, channelInfo);
          if (this.State.speakerInfo && this.State.speakerInfo.rtilCode == payload.id) {
            this.speakStream = channelInfo;
            this.$set(this.speakStream, 'hasUnsubscribe', this.dealSpeakStreamHasUnsubscribe);
          }
          // anywhereSetting设置
          if (type == 'Anywhere') {
            this.$set(this.anyWherePlatForms, payload.id, result.devicePlatform);
            this.$set(this.anyWherePeerIds, payload.id, result.devicePeerId);
          }
          // 远程控制支持PartylineApp
          if (type == 'App') {
            var _result$accountId;
            this.$set(this.anyWherePeerIds, payload.id, (_result$accountId = result.accountId) === null || _result$accountId === void 0 ? void 0 : _result$accountId.split('_')[1]);
          }
          if (this.State.talkInfo && this.State.talkInfo.rtilCode == payload.id) {
            this.talkStream = channelInfo;
            this.$set(this.talkStream, 'hasUnsubscribe', this.dealTalkStreamHasUnsubscribe);
          }
          if (channelInfo.shareCode && channelInfo.shareCode == payload.id) {
            this.shareStream = channelInfo;
            this.$set(this.shareStream, 'hasUnsubscribe', this.dealShareStreamHasUnsubscribe);
          }
          if (this.outPutRtilCode && this.outPutRtilCode == payload.id) {
            this.speakStream = channelInfo;
            this.$set(this.speakStream, 'hasUnsubscribe', this.dealSpeakStreamHasUnsubscribe);
          }
          this.$set(this.questionerStreamMap, payload.id, channelInfo);
        }
      } catch (error) {}
      Object.keys(this.questionerList).forEach(id => {
        if (this.questionerList[id].rtilCode != this.userInfo.rtilCode) {
          if (this.questionerList[id].rtilCode == payload.id) {
            if (this.State.audioType == 1) {
              this.$set(this.questionerStream, this.questionerList[id].rtilCode, {
                id: this.questionerList[id].rtilCode,
                hasUnsubscribe: true
              });
            } else {
              this.rtc.subscribe(this.questionerList[id].rtilCode, 'video', 'unExecuteCallback');
              this.$set(this.questionerStream, this.questionerList[id].rtilCode, {
                id: this.questionerList[id].rtilCode,
                hasUnsubscribe: false
              });
            }
          }
        }
      });

      // 分享屏幕
      if (this.shareStream.id != this.userInfo.rtilCode && this.shareStream.id) {
        if (this.State.audioType == 1) {
          if (this.State.checkShareScreen || this.State.audioType == 2) {
            this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
            this.shareStream.hasUnsubscribe = false;
            this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
          } else {
            this.shareStream.hasUnsubscribe = true;
            this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkShareScreen) {
              this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
              this.shareStream.hasUnsubscribe = false;
              this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
            } else {
              this.shareStream.hasUnsubscribe = true;
              this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
            }
          } else {
            this.shareStream.hasUnsubscribe = false;
            this.dealShareStreamHasUnsubscribe = this.shareStream.hasUnsubscribe;
            this.rtc.subscribe(this.shareStream.id, 'video', 'unExecuteCallback');
          }
        }
      }

      // 主讲人
      if (this.speakStream.id != this.userInfo.rtilCode && this.speakStream.id && this.outPutRtilCode == payload.id) {
        // 先判断当前 audio-only 选择的模式
        if (this.State.audioType) {
          if (this.State.checkMainWindow || this.State.audioType == 2) {
            this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
            this.speakStream.hasUnsubscribe = false;
            this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
          } else {
            this.speakStream.hasUnsubscribe = true;
            this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkMainWindow) {
              this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
              this.speakStream.hasUnsubscribe = false;
              this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
            } else {
              this.speakStream.hasUnsubscribe = true;
              this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
            }
          } else {
            this.speakStream.hasUnsubscribe = false;
            this.dealSpeakStreamHasUnsubscribe = this.speakStream.hasUnsubscribe;
            this.rtc.subscribe(this.speakStream.id, 'video', 'unExecuteCallback');
          }
        }
      }
      if (this.outPutRtilCode != payload.id && this.talkStream.id != this.userInfo.rtilCode && this.talkStream.id) {
        // 提问者
        // 先判断当前 audio-only 选择的模式
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            this.rtc.subscribe(this.talkStream.id, 'video', 'unExecuteCallback');
            this.talkStream.hasUnsubscribe = false;
            this.dealTalkStreamHasUnsubscribe = this.talkStream.hasUnsubscribe;
          } else {
            this.talkStream.hasUnsubscribe = true;
            this.dealTalkStreamHasUnsubscribe = this.talkStream.hasUnsubscribe;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            // if (this.State.checkMainWindow) {
            //   this.rtc.subscribe(this.talkStream.id, 'video', 'unExecuteCallback')
            //   this.talkStream.hasUnsubscribe = false
            //   this.dealTalkStreamHasUnsubscribe = this.talkStream.hasUnsubscribe
            // } else {
            this.talkStream.hasUnsubscribe = true;
            this.dealTalkStreamHasUnsubscribe = this.talkStream.hasUnsubscribe;
            // }
          } else {
            this.talkStream.hasUnsubscribe = false;
            this.dealTalkStreamHasUnsubscribe = this.talkStream.hasUnsubscribe;
            this.rtc.subscribe(this.talkStream.id, 'video', 'unExecuteCallback');
          }
        }
      }
    },
    getPartyInfo(id, illegalPartyCode) {
      if (!id) return;
      const params = {};
      if (illegalPartyCode) {
        params._illegalPartyCode = illegalPartyCode;
      }
      this.axios.get(`/partyline-backend/party/${id}`, {
        params
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          const {
            code,
            title,
            id,
            createTime
          } = result;
          this.State.currentPartyInfo = result;
          setTimeout(() => {
            Bus.$emit('changePartyAddress', {
              currentId: code,
              lastId: id,
              init: 'initAside',
              title,
              id,
              createTime
            });
          }, 500);
        }
      });
    },
    controlInvite(val) {
      const params = {
        collaborateLogId: this.collaborateInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('galleryHost.operationS'));
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    dealFootEvent(info) {
      const {
        type,
        val,
        shareType
      } = info;
      switch (type) {
        case 'muteVideo':
        case 'muteAudio':
          this.operateCallback({
            type,
            id: this.userInfo.rtilCode,
            value: val
          });
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'changeMute':
          this.changeMute(!val);
          break;
        case 'shareScreen':
          this.shareScreen(shareType);
          break;
        case 'showChat':
          this.State.showChatMessage = val;
          if (val) {
            this.showUnread = false;
            this.loadChatBox = true;
          }
          break;
      }
    },
    switchDevice(obj) {
      if (obj.type == 'speaker') {
        handleLocalStorage('set', 'speakerId', obj.deviceId);
        // mainWindow切换
        if (this.userInfo.rtilCode != this.speakStream.id) {
          var _this$$refs$speakerVi;
          (_this$$refs$speakerVi = this.$refs.speakerVideo) === null || _this$$refs$speakerVi === void 0 ? void 0 : _this$$refs$speakerVi.setSpeakerAttendUser();
        }
        if (this.userInfo.rtilCode != this.talkStream.id) {
          var _this$$refs$talkInfoV;
          (_this$$refs$talkInfoV = this.$refs.talkInfoVideo) === null || _this$$refs$talkInfoV === void 0 ? void 0 : _this$$refs$talkInfoV.setSpeakerAttendUser();
        }
        if (this.$refs.shareStreamBox) {
          var _this$$refs$shareStre;
          (_this$$refs$shareStre = this.$refs.shareStreamBox) === null || _this$$refs$shareStre === void 0 ? void 0 : _this$$refs$shareStre.setSpeakerAttendUser();
        }
      }
      this.rtc && this.rtc.setDevice(obj.deviceId, obj.type, result => {
        if (obj.type == 'audio' && result === 'success') {
          // 判断当前是否有 speaker 并且是 host
          if (this.speakStream.id && this.speakStream.id == this.userInfo.rtilCode) {
            var _this$$refs$speakerVi2;
            (_this$$refs$speakerVi2 = this.$refs.speakerVideo) === null || _this$$refs$speakerVi2 === void 0 ? void 0 : _this$$refs$speakerVi2.reAddAudioContext();
          }
          if (this.talkStream.id && this.talkStream.id == this.userInfo.rtilCode) {
            var _this$$refs$talkInfoV2;
            (_this$$refs$talkInfoV2 = this.$refs.talkInfoVideo) === null || _this$$refs$talkInfoV2 === void 0 ? void 0 : _this$$refs$talkInfoV2.reAddAudioContext();
          }
          // this.$refs.
        }
      });
    },

    shareScreen(shareType) {
      if (shareType === 'stopShare') {
        this.stopShare({
          id: this.shareRtilCode
        }, 'byClickShareIcon');
        return;
      }
      const params = {
        memberId: `${this.userInfo.rtilCode}_sharescreen`,
        partyCode: this.partyCode,
        role: 0,
        type: 3,
        host: true,
        whetherSendViewPosition: 0 // 不推送viewPosition
      };

      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          const {
            appId,
            tokenCode,
            rtilCode,
            realPartyCode
          } = res.data.result;
          const temp = {
            appId,
            channel: realPartyCode + '',
            token: tokenCode,
            uid: rtilCode,
            share: true,
            subscribeRemote: false,
            status: this.userInfo.status
          };
          this.shareRtilCode = rtilCode;
          this.State.shareRtilCode = rtilCode;
          this.sendShareCommand(res.data.result);
          this.shareClient = new AgoraRTCClient(this.callBack);
          await this.shareClient.join(temp); // 初始化视频流
          this.saveShareName(res.data.result);
          this.$set(this.State.localShareInfo, rtilCode, this.userInfo.rtilCode);
        } else if (res.data.errorCode === '80520113') {
          this.$message.error(this.$t('partyInfo.partyDisabled'));
        }
      });
    },
    saveShareName({
      rtilCode
    }) {
      if (!rtilCode || !this.userInfo.joinCode) return;
      const params = [{
        mark: String(rtilCode),
        annotation: this.userInfo.joinCode,
        key: 'nickName',
        notify: true,
        value: this.nickNameInfo[this.MeInfo.id] + '_Screen_Share',
        initiator: String(rtilCode)
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {});
    },
    sendShareCommand(shareParams) {
      const {
        rtilCode,
        memberId
      } = shareParams;
      const params = {
        partyCode: this.$route.query.id,
        module: 'shareScreen',
        msg: {
          shareMsg: JSON.stringify({
            rtilCode,
            memberId: this.State.loginInfo.id,
            initiator: this.userInfo.rtilCode,
            nickName: this.userInfo.behavior.nickName
          }),
          memberId
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=6416', params);
    },
    stopShare(payload, byClickShareIcon) {
      this.cancelShareCommand(payload.id);
      if (byClickShareIcon) {
        if (this.shareClient && this.shareClient._shareTrack) {
          this.shareClient._shareTrack._mediaStreamTrack.stop();
          this.shareClient && this.shareClient.leave();
        }
      }
    },
    cancelShareCommand(id) {
      const params = {
        partyCode: this.partyCode,
        module: 'cancelShareScreen',
        origin: 'commonPartyHost',
        msg: {
          rtilCode: id
        }
      };
      if (!id) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=2055', params).then(res => {});
    },
    async operateCallback(obj) {
      // 更新状态
      const {
        type,
        id,
        value
      } = obj;
      if (type === 'muteVideo') {
        if (id == this.userInfo.rtilCode) {
          if (!this.devicesInfo.cameraId) {
            this.State.guideObjShow = true;
            return;
          }
          if (value) {
            this.rtc._localVideoTrack && this.rtc._localVideoTrack.setEnabled(true);
          } else {
            this.rtc._localVideoTrack && this.rtc._localVideoTrack.setEnabled(false);
          }
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'camera',
            value,
            partyCode: this.userInfo.joinCode,
            toRtilCode: id,
            origin: 'conferenceHost'
          });
        }
      } else if (type === 'muteAudio') {
        if (!this.devicesInfo.microphoneId) {
          this.$message.error('no microphone');
          return;
        }
        let operationResult = 'success';
        if (this.rtc._localAudioTrack) {
          const type = value ? 'publish' : 'unpublish';
          operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
        } else {
          // 初始化的时候没有本地音频轨道，需要重新获取
          controlAudio(this.rtc, this.devicesInfo, value, result => {
            if (result == 'failed') operationResult = 'failed';
          });
        }
        if (operationResult == 'success') {
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'mic',
            value,
            partyCode: this.userInfo.joinCode,
            toRtilCode: id,
            origin: 'conferenceHost'
          });
        }
      }
    },
    moveParty(val, rtilCode) {
      this.attendCallback({
        type: 'moveParty',
        id: rtilCode,
        status: val,
        sign: 'batch'
      });
    },
    editTagName(obj) {
      this.setTagName.show = true;
      this.setTagName.originRtilCode = this.userInfo.rtilCode;
      this.setTagName.targetRtilCode = obj.id;
      this.setTagName.partyCode = this.currentPartyInfo.code;
      this.setTagName.tagName = this.tagNameInfo[obj.id];
    },
    saveTagName(obj) {
      this.$set(this.tagNameInfo, obj.rtilCode, obj.tagName);
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        const rtilCodes = Object.keys(this.allAccountIdByRtilCode);
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: rtilCodes,
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket.client.readyState === 1) {
          socket.send(params);
        }
      }, 1000);
    },
    chatCallback(obj) {
      const {
        type
      } = obj;
      if (type == 'onlineMembers') {
        this.getAllPartyNum();
      } else if (type == 'editTagName') {
        this.editTagName(obj);
      } else if (type == 'moveParty') {
        this.attendCallback(obj);
      } else if (type == 'nickName') {
        this.getNickName(obj.rtilCode);
      } else if (type == 'unreadInfo') {
        Object.keys(obj.data).forEach(keys => {
          if (obj.data[keys].unRead) {
            Bus.$emit('chatUnread', true);
            this.showUnread = true;
          }
        });
      }
    },
    getAllPartyNum() {
      if (!this.partyCode) return;
      this.axios.get(`/partyline-backend/conference/onlineMembers/${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          // 获取所有人的平铺数据
          this.allPartyMembers = [];
          Object.keys(res.data.result).forEach(key => {
            res.data.result[key].forEach(val => {
              if (val !== null && val !== void 0 && val.nickName) this.allPartyMembers.push(val.rtilCode);
            });
          });
        }
      });
    },
    returnLable(item) {
      let _str = item;
      if (item.nickName) {
        _str = `${item.nickName}${item.rtilCode == this.rtilCode ? '(Me)' : ''}${this.tagNameInfo[item.rtilCode] ? ` / ${this.tagNameInfo[item.rtilCode]}` : ''}`;
      } else {
        _str = item == 'Default' ? 'Live source' : item;
      }
      return _str;
    },
    returnValue(item) {
      let _str = item;
      if (item.rtilCode) {
        _str = item.rtilCode + ',' + item.nickName;
      }
      return _str;
    },
    attendCallback(obj) {
      let {
        type,
        nickName,
        rtilCode,
        id,
        val
      } = obj;
      if (type == 'setSpeaker') {
        if (this.State.speakerInfo && rtilCode == this.State.speakerInfo.rtilCode) return;
        this.setSpeaker(`${rtilCode},${nickName}`);
      }
      if (type == 'cancelSpeaker') {
        this.cancelLastSpeaker('none,none');
      }
      if (type == 'cancelQuestionSpeaker' || type == 'hangUpInterview') {
        this.cancelQuestionSpeaker();
      }
      if (type == 'addQuestioner') {
        this.setQuestioner(obj);
      }
      if (type == 'muteAudio' || type == 'muteVideo') {
        this.setCameraOrMic({
          type,
          id,
          val
        });
      }
      if (type == 'editTagName') {
        this.editTagName(obj);
      }
      if (type == 'fullScreen') {
        if (this.shareInfo && this.shareInfo.rtilCode == id) {
          this.showShareFullScreen = val;
        }
        if (this.State.speakerInfo && this.State.speakerInfo.rtilCode == id || this.outputSourceType == 'PGM' || this.outputSourceType == 'Default' || this.outPutRtilCode) {
          this.showSpeakerFullScreen = val;
        }
        if (this.State.talkInfo && this.State.talkInfo.rtilCode == id) {
          this.showTalkFullScreen = val;
        }
        if (val && getFullscreenEnabled()) {
          this.$refs.coordinatorBox.requestFullscreen();
        }
      }
      if (type == 'moveParty') {
        id = String(id);
        if (obj.sign == 'batch') {
          // 批量
          if (obj.status) {
            var _this$batchMovePartyI;
            if (!((_this$batchMovePartyI = this.batchMovePartyInfo.rtilCodes) !== null && _this$batchMovePartyI !== void 0 && _this$batchMovePartyI.includes(id))) {
              this.batchMovePartyInfo.rtilCodes.push(id);
            }
          } else {
            this.batchMovePartyInfo.rtilCodes = this.batchMovePartyInfo.rtilCodes.filter(v => v != id);
          }
        } else {
          this.movePartyInfo.show = true;
          this.movePartyInfo.rtilCodes = [String(id)];
        }
      }
      if (type === 'anyWhereSetting') {
        this.getNickName(id, '', 'anyWhereSetting');
        this.anyWhereInfo.rtilCode = id;
        let obj = {};
        // 置空打开anyWhereSetting弹窗对应的列表流
        if (this.State.talkInfo && this.State.talkInfo.rtilCode == id) {
          this.anyWhereRtilCodeObj = this.talkStream;
          this.talkStream = {};
          setTimeout(() => {
            this.anywhereSettingShow = true;
          }, 500);
          obj = this.talkStream;
        } else {
          this.anyWhereRtilCodeObj = this.questionerStreamMap[id];
          this.$set(this.questionerStreamMap, id, {});
          setTimeout(() => {
            this.$set(this.anywhereSettingShowMap, id, true);
          }, 500);
          obj = Object.assign({}, this.questionerStreamMap[id]);
        }
        this.anyWhereVideoAudioInfo = {
          rtilCode: id,
          id: id
        };
        if (this.rtc._subscribeTrack[id]) {
          obj.id = id;
          obj.videoTrack = this.rtc._subscribeTrack[id].videoTrack;
          obj.audioTrack = this.rtc._subscribeTrack[id].audioTrack;
          this.anyWhereVideoAudioInfo = obj;
        }
      }
    },
    async setCameraOrMic({
      type,
      id,
      val
    }) {
      if (type === 'muteVideo') {
        if (id == this.userInfo.rtilCode) {
          if (val) {
            this.rtc._localVideoTrack && this.rtc._localVideoTrack.setEnabled(true);
          } else {
            this.rtc._localVideoTrack && this.rtc._localVideoTrack.setEnabled(false);
          }
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'camera',
            value: val,
            partyCode: this.userInfo.joinCode,
            toRtilCode: id,
            origin: 'conferenceHost'
          });
        } else {
          if (val) {
            this.$message.success(this.$t('commonFunction.operateSuccessful'));
          } else {
            this.$message.success(this.$t('kioskHost.requestHasBeenSend'));
          }
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'camera',
            value: val,
            partyCode: this.userInfo.joinCode,
            toRtilCode: id,
            origin: 'conferenceHost'
          });
        }
      } else {
        if (id == this.userInfo.rtilCode) {
          let operationResult = 'success';
          const type = val ? 'publish' : 'unpublish';
          if (val) {
            if (this.rtc._localAudioTrack) {
              operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
            } else {
              // 初始化的时候没有本地音频轨道，需要重新获取
              controlAudio(this.rtc, this.devicesInfo, val, result => {
                if (result == 'failed') operationResult = 'failed';
              });
            }
          } else {
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: val,
              partyCode: this.userInfo.joinCode,
              toRtilCode: id,
              origin: 'conferenceHost'
            });
          }
        } else {
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'mic',
            value: val,
            partyCode: this.userInfo.joinCode,
            toRtilCode: id,
            origin: 'conferenceHost'
          });
        }
        this.$message.success(this.$t('commonFunction.operateSuccessful'));
      }
    },
    changeBehaviorStatus(key, value, id) {
      if (!id || !this.userInfo.rtilCode || !this.$route.query.id) return;
      // 更新状态
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.$route.query.id,
        key,
        value
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          if (key === 'camera' && id == this.userInfo.rtilCode) {
            this.$set(this.State.cameraStatus, id, value);
          }
          if (key === 'mic' && id == this.userInfo.rtilCode) {
            this.$set(this.State.micStatus, id, value);
          }
        }
      });
    },
    changeLocalName(item) {
      if (!this.editNameVal || !this.rtilCode) return;
      const params = [{
        mark: this.rtilCode + '',
        annotation: this.partyCode,
        key: 'nickName',
        notify: true,
        value: this.editNameVal.replace(/(^\s*)|(\s*$)/g, '') // 去掉首尾空格
      }];

      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode == '0x0') {
          item.nickName = this.editNameVal + '(Me)';
          this.showLocalRenameInput = false;
        } else {
          this.$message.error(res.data.errorInfo);
        }
      });
    },
    callbackByLiveSource({
      type,
      val,
      filter
    }) {
      if (type == 'getReceiverList' && !filter) {
        this.getReceiverList(filter);
      } else if (type == 'getReceiverList' && filter) {
        if (this.getRListTimer) clearTimeout(this.getRListTimer);
        this.getRListTimer = setTimeout(() => {
          this.getReceiverList(filter, val);
        }, 500);
      } else if (type === 'startLive') {
        this.tipInfo.show = true;
      } else if (type === 'fullScreen') {
        if (val && getFullscreenEnabled()) {
          document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
        }
      }
    },
    getReceiverList(filter, val) {
      if (!filter) {
        this.getReceiverParams = {
          pageNum: 1,
          pageSize: 400,
          living: true,
          offline: false,
          online: true
        };
      } else {
        this.getReceiverParams = {
          living: true,
          offline: false,
          online: true,
          condition: val
        };
      }
      this.axios.post('/partyline-backend/receiver/v3/page', this.getReceiverParams).then(res => {
        if (res.data.errorCode === '0x0') {
          const array = [];
          const result = res.data.result;
          this.State.ppConferenceRlist = [];
          this.allRList = [];
          // receiver list
          const receiverObj = {};
          receiverObj.value = 'Receiver';
          receiverObj.label = 'Receiver';
          receiverObj.children = [];
          if (result.cc.list.length) {
            if (result.cc.list.length) {
              result.cc.list.forEach(item => {
                this.sourceIds.push(item.peerId);
                const itemInfo = {
                  ...item,
                  value: item.peerId,
                  label: item.name
                };
                receiverObj.children.push(itemInfo);
              });
            } else {
              receiverObj.disabled = true;
            }
            array.push(receiverObj);
          }
          // pp list
          const ppObj = {};
          ppObj.value = 'Producer';
          ppObj.label = 'Producer';
          if (result.pps && result.pps.length) {
            ppObj.children = this.dealPPList(result.pps);
          } else {
            ppObj.disabled = true;
          }
          array.push(ppObj);
          this.allRList = array;
        }
      });
    },
    dealPPList(list) {
      const array = [];
      list.forEach(item => {
        item.pageInfo.list.forEach(info => {
          this.State.slotList.push(info.rids);
          this.State.ppConferenceRlist.push(info);
          const ppObj = {};
          ppObj.value = info.receiverId;
          ppObj.label = info.name;
          ppObj.userInfo = item.user;
          ppObj.children = info.rids.map((slotId, index) => {
            return {
              value: slotId,
              label: `Slot${index + 1}`
            };
          });
          array.push(ppObj);
        });
      });
      return array;
    },
    async initJoinFn(newVal) {
      if (!newVal || (newVal + '').length != 9) return;
      this.rtc && (await this.rtc.leave());
      this.rtc = new AgoraRTCClient(this.callBack);
      this.devicesInfo = await this.rtc.getDevice();
      if (!handleLocalStorage('get', 'speakerId')) {
        handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
      }
      this.partyCode = Number(newVal);
      this.State.partyCode = newVal;
      if (this.setTimer) clearTimeout(this.setTimer);
      await this.getQuestionerList();
      this.joinPartyLine();
    },
    switchToSmallVideo() {
      this.allScreen = false;
    },
    switchToBigVideo() {
      this.allScreen = true;
    },
    async removeQuestioner() {
      const params = {
        partyCode: this.partyCode,
        module: 'cancelQuestioner',
        msg: {
          nickName: this.questionerList[0].nickName,
          rtilCode: this.questionerList[0].rtilCode
        }
      };
      this.visible = false;
      this.axios.post('/partyline-backend/party/noLogin/command?key=23120', params);
    },
    setDefaultConfig(notChange) {
      this.raiseHandList = [];
      this.speakStream = {};
      this.talkStream = {};
      this.State.speakerInfo = null;
      this.State.talkInfo = null;
      if (!notChange) this.questionerList = [];
    },
    joinPartyLine() {
      this.bestOffset = 0;
      this.hasGetTimeOffset = false;
      const partyCode = this.currentPartyInfo.code;
      this.$store.dispatch('checkEnv', {
        partyCode
      });
      const params = {
        memberId: this.loginInfo.id || 'PL_' + new Date().getTime(),
        partyCode: this.partyCode,
        role: 0,
        type: 2,
        host: true,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'flipVideo', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare']
      };
      this.axios.post('/partyline-backend/party/noLogin/join', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.$set(this.degreeHost, result.rtilCode, result.behavior.flipVideo);
          // 当party不是自己的时候，需要已参会者额身份加入
          if (!result.owner) {
            routerJump('participate', {
              join_id: result.joinCode
            });
            return;
          }
          addTabTitle({
            userInfo: result
          });
          this.userInfo = result;
          this.State.crewInfo.rtilCode = result.rtilCode;
          this.State.joinInfo = result;
          this.outputSourceType = result.status.outputType;
          this.State.partyJoinInfo = result;
          this.State.audioType = result.behavior.audioOnlyType ? Number(result.behavior.audioOnlyType) : 0;
          this.State.checkMainWindow = result.behavior.checkAudioMainWindow !== 'false';
          this.State.checkShareScreen = result.behavior.checkAudioShare !== 'false';
          result.status.volumeEffect === 0 ? this.isAudioLevel = true : this.isAudioLevel = false;
          Bus.$emit('changeAudioTypeVal');
          if (this.State.hadLoadPartyList) {
            this.State.newPageLoading = false;
          }
          // 传递GalleryView模式下的初始化数据
          Bus.$emit('initOperateData', result.status);
          Bus.$emit('getCollaborateInfo');
          // 获取初始化的一些状态
          Bus.$emit('getInitStatus', {
            videoQuality: result.status.videoQuality || 'low'
          });
          this.initPageStatus(result);
          this.allAccountIdByRtilCode[result.rtilCode] = params.memberId.toLowerCase();
          this.joinParam = {
            ...result,
            memberId: params.memberId,
            partyCode: this.partyCode
          };
          if (result.status.speaker || result.status.output) {
            this.State.speakerInfo = {
              rtilCode: result.status.speaker || result.status.output
            };
          }
          if (result.status.questionSpeaker) {
            this.State.talkInfo = {
              rtilCode: result.status.questionSpeaker
            };
          }
          if (result.behavior && result.behavior.nickName) {
            // result.behavior && result.behavior.nickName
            const nickName = result.behavior.nickName;
            // 设置过nickname，则不需要重新设置,直接join
            this.setNameInfo.show = false;
            this.$set(this.nickNameInfo, this.userInfo.rtilCode, nickName);
            result.behavior.speaker = result.behavior.speaker !== 'false';
            result.behavior.camera = result.behavior.camera !== 'false';
            result.behavior.mic = result.behavior.mic !== 'false';
            this.joinAgoraClient(result, result.behavior, this.joinParam);
            // 获取host的tagName
            this.getNickName(result.rtilCode);
          } else {
            var _this$$router, _this$$router$push;
            (_this$$router = this.$router) === null || _this$$router === void 0 ? void 0 : (_this$$router$push = _this$$router.push) === null || _this$$router$push === void 0 ? void 0 : _this$$router$push.call(_this$$router, {
              name: 'preview',
              query: {
                id: this.partyCode
              }
            });
          }
          this.getAllPartyNum();
        }
      });
    },
    async joinAgoraClient(result, obj, param) {
      if (!this.State.pageSerBusRequestWs[this.partyCode]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode: this.partyCode
        });
      }
      // join到agaro会议需要准备的数据
      this.State.isMute = !obj.speaker;
      this.$set(this.State.cameraStatus, result.rtilCode, obj.camera);
      this.$set(this.State.micStatus, result.rtilCode, obj.mic);
      // Me设置crew功能，使用到
      this.MeInfo = {
        id: result.rtilCode,
        tid: this.loginInfo.id,
        nickName: this.userInfo.behavior.nickName,
        info: {
          rtilCode: result.rtilCode
        },
        channel: param.realPartyCode
      };
      handleLocalStorage('set', 'manageRtilCode', result.status.managerRtil);
      handleLocalStorage('set', 'rtilCode', result.rtilCode);
      this.outPutRtilCode = result.status.output;
      this.selectRId = result.status.outputId;
      if (result.status.outputSource) {
        if (result.status.outputSource == 'PGM') {
          this.mainWindowType = 'pp';
        } else {
          this.mainWindowType = 'cc';
          this.selectValue = result.status.outputSource == 'Default' ? this.$t('audioChannels.liveSource') : result.status.outputSource;
        }
      }
      this.getMeetingInfo(param, result);
    },
    async getMeetingInfo(param, result) {
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        memberId,
        videoQualities
      } = param;
      const isSpeaker = !!(this.State.speakerInfo && this.State.speakerInfo.rtilCode == rtilCode);
      const isTalk = !!(this.State.talkInfo && this.State.talkInfo.rtilCode == rtilCode);
      const params = {
        appId,
        channel: realPartyCode + '',
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        videoConfig: videoQualities,
        publishVideo: this.State.cameraStatus[rtilCode],
        publishAudio: this.State.micStatus[rtilCode],
        video: !!this.devicesInfo.cameraId,
        audio: !!this.devicesInfo.microphoneId,
        // 传入用户选择的可用的音视频采集设备的id
        microphoneId: this.devicesInfo.microphoneId,
        cameraId: this.devicesInfo.cameraId,
        startProxy: result.status.cloudProxy === 1,
        executeLocalSubscribe: true,
        executeVideoAdded: true
      };
      this.rtilCode = rtilCode;
      this.realPartyCode = realPartyCode;
      this.State.currentRtilCode = rtilCode;
      this.getRaiseHandList();
      this.questionerList.forEach(item => {
        if (item.rtilCode == this.rtilCode) {
          // 初始化的时候如果host是questioner则需要把本地的声音视频打开
          this.State.showConferenceLocal = true;
        }
      });
      if (result.status.questionSpeaker == this.rtilCode) {
        this.State.showConferenceLocal = true;
      }
      const uid = await this.rtc.join(params);
      if (uid) {
        this.hadOpenWebCloud = result.status.cloudProxy === 1;
        this.State.controlInfo = {
          ...params,
          memberId: memberId
        };
        this.rtc._client && this.rtc._client.enableAudioVolumeIndicator();
        // host默认其他人听不见
        if (!isSpeaker && !isTalk && !this.State.showConferenceLocal) {
          this.rtc._localVideoTrack && this.rtc._localVideoTrack.setEnabled(false);
        }

        // 新增和用户行为的对比，以防止网络不好的时候无法状态统一
        if (this.checkInitAgoraStatusTimer) clearTimeout(this.checkInitAgoraStatusTimer);
        /// 更改hostjr userId
        const userId = rtilCode + '_' + this.MeInfo.nickName + '_' + this.partyCode;
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
        if (!this.hasGetTimeOffset) {
          var _this$userInfo$videoQ, _this$userInfo$videoQ2;
          const offset = await this.dealTimeOffset();
          this.bestOffset = offset;
          this.hasGetTimeOffset = true;
          const fps = (_this$userInfo$videoQ = this.userInfo.videoQualities) === null || _this$userInfo$videoQ === void 0 ? void 0 : (_this$userInfo$videoQ2 = _this$userInfo$videoQ[0]) === null || _this$userInfo$videoQ2 === void 0 ? void 0 : _this$userInfo$videoQ2.fps;
          const intervalTime = fps ? Math.round(1000 / fps) : 33;
          if (this.sendMetadataTimer) clearInterval(this.sendMetadataTimer);
          this.sendMetadataTimer = setInterval(() => {
            this.sendMetadata();
          }, intervalTime);
        }
      }
    },
    async dealTimeOffset() {
      let bestRTT = Infinity;
      let bestOffset = 0;
      for (var i = 0; i < 10; i++) {
        const t0 = Date.now();
        const serverTime = await this.getTimeOffset();
        const t1 = Date.now();
        const rtt = t1 - t0;
        const offset = Date.now() - (serverTime + Math.round(rtt / 2));
        if (rtt < bestRTT) {
          bestRTT = rtt;
          bestOffset = offset;
        }
      }
      return bestOffset;
    },
    async getTimeOffset() {
      return await this.axios.get('/partyline-backend/base/getServerTime').then(res => {
        return res.data;
      });
    },
    sendMetadata() {
      var _this$rtc$_client;
      if (!this.rtc.hasJoined) return;
      const params = {
        offset: this.bestOffset,
        rtilCode: this.rtilCode,
        timestamp: Date.now() + this.bestOffset
      };
      (_this$rtc$_client = this.rtc._client) === null || _this$rtc$_client === void 0 ? void 0 : _this$rtc$_client.sendMetadata(new TextEncoder().encode(JSON.stringify(params)), function (error) {
        if (error) console.log('sendMetadata', error);
      });
    },
    async callBack({
      action,
      payload
    }) {
      var _this$rtc$_localAudio, _this$rtc$_localAudio2;
      const {
        changeDevice,
        id,
        shareInfo
      } = payload;
      switch (action) {
        case 'user-joined':
          this.$set(this.questionerStreamMap, payload.id, {
            id: payload.id
          });
          this.getNickName(payload.id, this.State.speakerInfo && this.State.speakerInfo.rtilCode === payload.id && this.outputSourceType == 'Participant' ? 'speaker' : '');
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          this.dealSubscribeVideo(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'start-share':
          this.shareStream = {
            id,
            videoTrack: shareInfo.videoTrack,
            audioTrack: shareInfo.audioTrack
          };
          break;
        case 'user-published':
        case 'user-unpublished':
          this.muteAudioOrVideo(action, payload);
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          this.MeInfo = {
            id: this.userInfo.rtilCode,
            tid: this.loginInfo.id,
            nickName: this.userInfo.behavior.nickName,
            info: {
              rtilCode: this.userInfo.rtilCode
            },
            channel: this.partyCode,
            videoTrack: videoTrack,
            audioTrack: audioTrack
          };
          const info = {
            id: this.userInfo.rtilCode,
            channel: this.userInfo.realPartyCode,
            videoTrack: videoTrack,
            audioTrack: audioTrack,
            showLocal: true
          };
          this.$set(this.questionerStreamMap, this.userInfo.rtilCode, info);
          this.$set(this.rtc._remotePublishUser, this.userInfo.rtilCode, info);
          if (this.State.showConferenceLocal && this.userInfo.status.questionSpeaker && !this.talkStream.id) {
            this.talkStream = info;
          }
          if (this.State.speakerInfo && this.State.speakerInfo.rtilCode == this.userInfo.rtilCode) {
            this.speakStream = info;
          }
          break;
        case 'stop-share':
          this.shareRtilCode = '';
          this.stopShare(payload);
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        case 'cameraChange':
          if (!this.rtc) return;
          this.devicesInfo = await this.rtc.getDevice();
          if (this.rtc._localVideoTrack && changeDevice.device.label === this.rtc._localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc._AgoraRTC.getCameras();
            oldCameras[0] && this.rtc.setDevice(oldCameras[0].deviceId, 'video', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
              this.devicesInfo.cameraId = oldCameras[0].deviceId;
            });
          }
          break;
        case 'micChange':
          if (!this.rtc) return;
          this.devicesInfo = await this.rtc.getDevice();
          if (this.rtc._localAudioTrack && ((_this$rtc$_localAudio = this.rtc._localAudioTrack._deviceName) !== null && _this$rtc$_localAudio !== void 0 && _this$rtc$_localAudio.includes(changeDevice.device.label) || changeDevice.state === 'INACTIVE' && this.rtc._localAudioTrack._config.microphoneId == 'default')) {
            const oldMic = await this.rtc._AgoraRTC.getMicrophones();
            oldMic[0] && this.rtc.setDevice(oldMic[0].deviceId, 'audio', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewMicSuccess')) : this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
              this.devicesInfo.microphoneId = oldMic[0].deviceId;
              if (type === 'success') {
                if (this.userInfo.rtilCode != this.speakStream.id) {
                  var _this$$refs$speakerVi3;
                  (_this$$refs$speakerVi3 = this.$refs.speakerVideo) === null || _this$$refs$speakerVi3 === void 0 ? void 0 : _this$$refs$speakerVi3.setSpeakerAttendUser();
                }
                if (this.userInfo.rtilCode != this.talkStream.id) {
                  var _this$$refs$talkInfoV3;
                  (_this$$refs$talkInfoV3 = this.$refs.talkInfoVideo) === null || _this$$refs$talkInfoV3 === void 0 ? void 0 : _this$$refs$talkInfoV3.setSpeakerAttendUser();
                }
                if (this.$refs.shareStreamBox) {
                  var _this$$refs$shareStre2;
                  (_this$$refs$shareStre2 = this.$refs.shareStreamBox) === null || _this$$refs$shareStre2 === void 0 ? void 0 : _this$$refs$shareStre2.setSpeakerAttendUser();
                }
              }
            });
          } else if (changeDevice.state === 'ACTIVE' && this.rtc._localAudioTrack && !((_this$rtc$_localAudio2 = this.rtc._localAudioTrack._deviceName) !== null && _this$rtc$_localAudio2 !== void 0 && _this$rtc$_localAudio2.includes(changeDevice.device.label)) && this.rtc._localAudioTrack._config.microphoneId != 'default') {
            // 插入mic
            if (this.State.micStatus[this.userInfo.rtilCode]) {
              if (this.rtc._localAudioTrack) {
                controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
              } else {
                // 初始化的时候没有本地音频轨道，需要重新获取
                controlAudio(this.rtc, this.devicesInfo, true, result => {});
              }
            }
            if (this.userInfo.rtilCode != this.speakStream.id) {
              var _this$$refs$speakerVi4;
              (_this$$refs$speakerVi4 = this.$refs.speakerVideo) === null || _this$$refs$speakerVi4 === void 0 ? void 0 : _this$$refs$speakerVi4.setSpeakerAttendUser();
            }
            if (this.userInfo.rtilCode != this.talkStream.id) {
              var _this$$refs$talkInfoV4;
              (_this$$refs$talkInfoV4 = this.$refs.talkInfoVideo) === null || _this$$refs$talkInfoV4 === void 0 ? void 0 : _this$$refs$talkInfoV4.setSpeakerAttendUser();
            }
            if (this.$refs.shareStreamBox) {
              var _this$$refs$shareStre3;
              (_this$$refs$shareStre3 = this.$refs.shareStreamBox) === null || _this$$refs$shareStre3 === void 0 ? void 0 : _this$$refs$shareStre3.setSpeakerAttendUser();
            }
            if (this.devicesInfo.microphoneList[0].label != this.rtc._localAudioTrack._deviceName) {
              this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
            }
          }
          break;
        case 'playbackChange':
          if (!this.rtc) return;
          if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
            this.$t('common.notSupportSwitchSpeaker');
            return;
          }
          if (changeDevice.state !== 'ACTIVE' && this.rtc._localAudioTrack) {
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            const currentSpeakerList = await this.rtc._AgoraRTC.getPlaybackDevices();
            const haveUseDevice = currentSpeakerList.find(item => item.label == currentLabelArray[0].label);
            if (!haveUseDevice) {
              handleLocalStorage('set', 'speakerId', currentSpeakerList[0].deviceId);
              const array = Object.keys(this.channels).filter(rtilCode => {
                return rtilCode != this.userInfo.rtilCode;
              });
              array.forEach(rtilCode => {
                if (this.channels[rtilCode].audioTrack) {
                  var _this$channels$rtilCo, _this$channels$rtilCo2;
                  (_this$channels$rtilCo = (_this$channels$rtilCo2 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo === void 0 ? void 0 : _this$channels$rtilCo.call(_this$channels$rtilCo2, currentSpeakerList[0].deviceId);
                }
              });
            }
          }
          this.devicesInfo = await this.rtc.getDevice();
          break;
      }
    },
    // set,questionerStreamMap信息
    async subscribeTrack(payload) {
      if (!payload.id) return;
      try {
        const {
          data: res
        } = await this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`);
        if (res.errorCode == '0x0') {
          const result = res.result;
          const accountId = result.accountId.toLowerCase();
          const {
            videoTrack,
            audioTrack
          } = payload;
          const channelInfo = {
            ...payload,
            tid: accountId,
            info: {
              rtilCode: payload.id
            },
            videoTrack,
            audioTrack,
            shareCode: accountId.indexOf('_sharescreen') > -1 ? payload.id : ''
          };
          this.$set(this.channels, payload.id, channelInfo);
          if (this.State.speakerInfo && this.State.speakerInfo.rtilCode == payload.id) {
            this.speakStream = channelInfo;
            // this.$set(this.speakStream, 'hasUnsubscribe', this.dealSpeakStreamHasUnsubscribe)
          }

          if (this.State.talkInfo && this.State.talkInfo.rtilCode == payload.id) {
            this.talkStream = channelInfo;
            // this.$set(this.talkStream, 'hasUnsubscribe', this.dealTalkStreamHasUnsubscribe)
          }

          const isNotTalkRtilCode = !this.State.talkInfo || this.State.talkInfo.rtilCode != payload.id;
          const isNotSpeakerRtilCode = !this.State.speakerInfo || this.State.speakerInfo.rtilCode != payload.id;
          if (this.PrivateInfo && this.PrivateInfo.rtilCode == payload.id && isNotTalkRtilCode && isNotSpeakerRtilCode) {
            this.privateStream = channelInfo;
          }
          if (this.shareInfo && this.shareInfo.rtilCode == payload.id) {
            this.shareStream = channelInfo;
            // this.$set(this.shareStream, 'hasUnsubscribe', this.dealShareStreamHasUnsubscribe)
          }

          if (this.outPutRtilCode && this.outPutRtilCode == payload.id) {
            this.speakStream = channelInfo;
            // this.$set(this.speakStream, 'hasUnsubscribe', this.dealSpeakStreamHasUnsubscribe)
          }

          this.$set(this.talkStream, 'hasUnsubscribe', this.dealTalkStreamHasUnsubscribe);
          this.$set(this.shareStream, 'hasUnsubscribe', this.dealShareStreamHasUnsubscribe);
          this.$set(this.speakStream, 'hasUnsubscribe', this.dealSpeakStreamHasUnsubscribe);
          this.$set(this.questionerStreamMap, payload.id, channelInfo);
          if (this.anyWhereInfo.show && payload.id == this.anyWhereInfo.rtilCode) {
            this.anyWhereVideoAudioInfo = this.questionerStreamMap[this.anyWhereInfo.rtilCode];
          }
          // 获取所有T的id，为了获取liveSource的info
          if (res.result.deviceType == 'T') {
            if (!this.sourceTIds.includes(res.result.accountId)) this.sourceTIds.push(res.result.accountId);
          }
          // 为了live时，找出rtilcode与account的一一对应关系
          this.allAccountIdByRtilCode[payload.id] = res.result.accountId.toLowerCase();
        }
      } catch (error) {}
    },
    userLeave(payload) {
      const {
        id
      } = payload;
      if (this.State.talkInfo && this.State.talkInfo.rtilCode == payload.id || !this.State.talkInfo) this.talkStream = {};
      // 如果anyWhere当前弹窗开着需要关闭
      if (id == this.anyWhereInfo.rtilCode) {
        this.anyWhereInfo.show = false;
        this.$set(this.anywhereSettingShowMap, this.anyWhereInfo.rtilCode, false);
        this.anywhereSettingShow = false;
        this.anyWhereInfo.rtilCode = '';
        this.anyWhereVideoAudioInfo = null;
        this.$message.success(this.$t('anywhereSetting.userLeft'));
      }
      this.$delete(this.questionerStreamMap, id);
      if (this.State.localShareInfo[id]) this.$delete(this.State.localShareInfo, id);
    },
    muteAudioOrVideo(action, payload) {
      const {
        id,
        mediaType
      } = payload;
      const value = action === 'user-published';
      mediaType === 'video' ? this.$set(this.State.cameraStatus, id, value) : this.$set(this.State.micStatus, id, value);
    },
    initPageStatus(result) {
      const {
        privateConversation,
        questionSpeaker,
        speaker,
        shareScreen
      } = result.status;
      if (speaker) {
        this.getNickName(speaker, 'speaker');
      }
      if (questionSpeaker) {
        this.getNickName(questionSpeaker, 'questionSpeaker');
      }
      this.State.privateInfo = JSON.parse(privateConversation) || {};
      if (shareScreen) {
        this.shareInfo = JSON.parse(shareScreen);
        this.allScreen = false;
      }
    },
    async getNickName(rtilCode, key, anyWhereSetting) {
      if (!this.partyCode) return;
      const params = {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.partyCode,
        keys: ['nickName', 'tagName', 'organization', 'flipVideo', 'resolution', 'fps', 'resolutionOptions', 'fpsOptions', 'whiteBalance', 'whiteBalanceRange', 'cameraOptions', 'whiteBalancePredefined', 'lock', 'whiteBalanceAuto', 'cameraPosition', 'defaultView', 'autoFocus', 'focusDistance', 'focusDistanceRange', 'autoExposure', 'exposure', 'exposureRange', 'zoom', 'zoomRange', 'isSupportGimbal', 'speakerVolume', 'speakerStatus', 'gimbalAngleValue', 'gimbalAngleRange'],
        marks: [rtilCode]
      };
      await this.axios.post('/partyline-backend/behavior/noLogin/getList', params).then(res => {
        if (!res.data.result) return;
        const {
          nickName,
          organization,
          tagName
        } = res.data.result[rtilCode];
        this.$set(this.degreeHost, rtilCode, res.data.result[rtilCode].flipVideo);
        const result = res.data.result[rtilCode];
        if (key === 'speaker') {
          this.mainWindowType = 'Speaker';
          this.selectValue = nickName;
          this.State.speakerInfo = {
            rtilCode: rtilCode,
            nickName: nickName,
            organization: organization
          };
        } else if (key == 'questionSpeaker') {
          this.State.talkInfo = {
            rtilCode: rtilCode,
            nickName: nickName,
            organization: organization
          };
        }
        this.$set(this.anyWhereSettings, rtilCode, {
          fps: result.fps,
          resolution: result.resolution,
          whiteBalance: JSON.parse(result.whiteBalance),
          lock: result.lock,
          whiteBalanceAuto: result.whiteBalanceAuto,
          cameraPosition: result.cameraPosition,
          resolutionOptions: result.resolutionOptions,
          fpsOptions: result.fpsOptions,
          whiteBalanceRange: result.whiteBalanceRange,
          cameraOptions: result.cameraOptions,
          whiteBalancePredefined: result.whiteBalancePredefined,
          defaultView: result.defaultView,
          autoFocus: result.autoFocus,
          focusDistanceRange: result.focusDistanceRange,
          focusDistance: result.focusDistance ? result.focusDistance : 0,
          autoExposure: result.autoExposure,
          exposureRange: result.exposureRange,
          exposure: result.exposure ? result.exposure : 0,
          zoom: result.zoom ? result.zoom : 0,
          zoomRange: result.zoomRange,
          isSupportGimbal: result.isSupportGimbal,
          speakerVolume: result.speakerVolume ? result.speakerVolume : 100,
          speakerStatus: result.speakerStatus,
          gimbalAngleValue: result.gimbalAngleValue,
          gimbalAngleRange: result.gimbalAngleRange
        });
        if (anyWhereSetting) {
          this.anyWhereInfo.show = true;
        }
        this.$set(this.tagNameInfo, rtilCode, tagName);
        this.$set(this.nickNameInfo, rtilCode, nickName);
        this.$set(this.organizationInfo, rtilCode, organization);
      });
    },
    returnStream(item) {
      let stream = {};
      if (item && this.questionerStreamMap[item.rtilCode]) {
        if (item.rtilCode == this.userInfo.rtilCode) {
          this.questionerStreamMap[item.rtilCode].showLocal = true;
          stream = this.questionerStreamMap[item.rtilCode];
        } else {
          Object.keys(this.questionerStream).forEach(id => {
            if (item.rtilCode == this.questionerStream[id].id) {
              this.questionerStreamMap[item.rtilCode].hasUnsubscribe = this.questionerStream[id].hasUnsubscribe;
            }
          });
          stream = this.questionerStreamMap[item.rtilCode];
        }
      }
      return stream;
    },
    changeMute(value) {
      this.$store.dispatch('isMute', !this.State.isMute);
      if (value) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      }
      this.changeBehaviorStatus('speaker', value, this.rtilCode);
    },
    getRaiseHandList() {
      const params = {
        conferenceCode: this.partyCode,
        pageNum: this.sendRaiseHandParams.pageNum,
        pageSize: this.sendRaiseHandParams.pageSize
      };
      this.axios.post('/partyline-backend/conference/noLogin/pageRaiseHand', params).then(res => {
        if (res.data.errorCode === '0x0') {
          res.data.result.list.forEach(v => {
            v.visibles = false;
          });
          this.raiseHandList = res.data.result.list;
          Bus.$emit('saveConferenceRaise', res.data.result.list);
        }
      });
    },
    getQuestionerList() {
      return new Promise((resolve, reject) => {
        this.axios.get(`/partyline-backend/conference/noLogin/questionerList/${this.partyCode}`).then(res => {
          if (res.data.errorCode === '0x0') {
            this.questionerList = res.data.result;
          }
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    getMainWindowList() {
      const params = {
        pageNum: 1,
        pageSize: 100,
        living: true,
        offline: false,
        online: true
      };
      this.axios.post('/partyline-backend/receiver/v2/page', params).then(res => {
        const none = [{
          label: 'None',
          list: [{
            name: 'None',
            receiverId: 'None'
          }]
        }];
        const speaker = [{
          label: 'Speaker',
          list: [{
            name: 'Speaker',
            receiverId: 'Speaker'
          }]
        }];
        const pgmList = [{
          label: 'Producer PGM',
          list: []
        }];
        const vfbList = [{
          label: 'VideoFeedBack',
          list: []
        }];
        const result = res.data.result;

        // pp list
        if (!result.pp.list.length) {
          pgmList[0].list = [{
            name: '--',
            receiverId: 'nonePP'
          }];
        } else {
          // 手动添加类型后续都要用
          result.pp.list.forEach(item => {
            item.sourceType = 'pp';
          });
          pgmList[0].list = result.pp.list;
        }
        // cc list
        if (!result.cc.list.length) {
          vfbList[0].list = [{
            name: '--',
            receiverId: 'noneCC'
          }];
        } else {
          result.cc.list.forEach(item => {
            item.sourceType = 'cc';
          });
          vfbList[0].list = result.cc.list;
        }
        this.mainWindowList = none.concat(speaker).concat(pgmList).concat(vfbList);
      });
    },
    receiverJoin(realPartyCode, origin, receiverId) {
      receiverId = receiverId.trim();
      const params = {
        origin,
        output: true,
        partyCode: realPartyCode,
        receiverId: receiverId,
        source: this.sourceSelect
      };
      this.axios.post('/partyline-backend/party/receiverJoin', params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '82201204') {
          const result = JSON.parse(res.data.errorInfo);
          const array = [];
          result.encoders.forEach(item => {
            const obj = {};
            obj.code = item.code;
            obj.title = item.title ? item.title : new Date(item.createTime).toLocaleDateString() + ' ' + new Date(item.createTime).toLocaleTimeString();
            obj.mode = this.ChannelMode[item.mode] ? this.ChannelMode[item.mode].toLowerCase() : '';
            obj.email = item.loginUser.email;
            array.push(obj);
          });
          this.encoderInfo.maxNumber = result.maxEncoderNumber;
          this.encoderInfo.data = array;
          this.encoderInfo.visible = true;
        } else if (res.data.errorCode === '0x0') {
          this.$message({
            type: 'success',
            message: this.$t('conferenceHost.setPgmSuccess')
          });
        } else {
          this.$message({
            type: 'error',
            message: res.data.errorInfo
          });
        }
      });
    },
    setSelect(info) {
      if (this.mainWindowType == 'Speaker') {
        this.setSpeaker(info);
      } else {
        this.sourceSelect = info;
        this.receiverJoin(this.realPartyCode, 'cc', this.selectRId);
      }
    },
    async setSpeaker(rtilCodeNickname) {
      if (this.State.speakerInfo || rtilCodeNickname === 'none,none') {
        this.cancelLastSpeaker(rtilCodeNickname);
        return;
      }
      const array = rtilCodeNickname.split(',');
      await this.getNickName(array[0], 'speaker');
      const parmas = {
        partyCode: this.State.partyCode,
        sourceType: 'Participant',
        pipSource: {
          rtilCode: array[0],
          nickName: array[1]
        }
      };
      this.axios.post('/partyline-backend/conference/startPushStream', parmas).then(res => {
        if (res.data.errorCode === '0x0') {
          this.selectValue = array[1];
          this.mainWindowType = 'Speaker';
          this.$message({
            type: 'success',
            message: this.$t('conferenceHost.setSpeakerSuccess')
          });
        }
      });
    },
    cancelLastSpeaker(rtilCodeNickname) {
      if (!this.State.speakerInfo) {
        this.selectValue = '';
        return;
      }
      if (this.State.speakerInfo.rtilCode == rtilCodeNickname.split(',')[0]) return;
      const parmas = {
        partyCode: this.State.partyCode
      };
      this.axios.post('/partyline-backend/conference/stopPushStream', parmas).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.speakerInfo = null;
          if (rtilCodeNickname == 'none,none') {
            this.selectValue = '';
            return;
          }
          this.setSpeaker(rtilCodeNickname);
        }
      });
    },
    setNickName(obj) {
      if (this.userInfo.behavior && this.userInfo.behavior.nickName) {
        this.userInfo.behavior.nickName = obj.nickName;
        this.userInfo.behavior.organization = obj.organization;
        return;
      }

      // 只有设置了nickname才可以join到会议
      this.userInfo.behavior = obj;
      this.$set(this.nickNameInfo, this.userInfo.rtilCode, obj.nickName);
      this.joinAgoraClient(this.userInfo, obj, this.joinParam);
    },
    setQuestioner(item) {
      if (this.setLoading) return;
      this.setLoading = true;
      const params = {
        partyCode: this.State.partyCode,
        module: 'setQuestioner',
        msg: {
          nickName: item.nickName,
          organization: item.organization,
          rtilCode: item.rtilCode
        }
      };
      item.visible = false;
      this.axios.post('/partyline-backend/party/noLogin/command?key=2199', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message({
            type: 'success',
            message: this.$t('conferenceHost.setQuestionerSuccess')
          });
          this.$refs.audience && this.$refs.audience.changeAudience({
            rtilCode: item.rtilCode
          }, 'delete');
        }
        setTimeout(() => {
          this.setLoading = false;
        }, 500);
      });
    },
    removePeople(item) {
      if (!this.partyCode) return;
      const params = {
        partyCode: this.partyCode,
        groupId: this.userInfo.joinCode,
        rtilCode: item.rtilCode
      };
      item.visible = false;
      this.axios.post(`/partyline-backend/partyAction/removeParticipant?partyCode=${this.partyCode}&key=11223`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message({
            type: 'success',
            message: this.$t('removeParty.removeS')
          });
          this.cancelRaiseHand(item);
        } else {
          this.$message({
            type: 'error',
            message: res.data.errorInfo
          });
        }
      });
    },
    cancelRaiseHand(item) {
      const params = {
        partyCode: this.partyCode,
        module: 'denyRaiseHand',
        msg: {
          nickName: item.nickName,
          rtilCode: item.rtilCode
        }
      };
      item.visibles = false;
      this.axios.post('/partyline-backend/party/noLogin/command?key=61791', params).then(res => {});
    },
    setPrivateChat(item) {
      if (this.setLoading) return;
      this.setLoading = true;
      if (this.PrivateInfo.rtilCode == item.rtilCode) {
        this.cancelPrivateChat(item);
        return;
      }
      const parmas = {
        partyCode: this.partyCode,
        module: 'startPrivateConversation',
        msg: {
          rtilCode: item.rtilCode,
          crewRtilCode: this.rtilCode
        }
      };
      item.visible = false;
      this.axios.post('/partyline-backend/party/noLogin/command?key=65744', parmas).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message({
            type: 'success',
            message: this.$t('partylineGuest.createPrivateConversation')
          });
        }
        setTimeout(() => {
          this.setLoading = false;
        }, 500);
      });
    },
    cancelPrivateChat(item) {
      const parmas = {
        partyCode: this.partyCode,
        module: 'cancelPrivateConversation',
        msg: {
          rtilCode: item.rtilCode,
          crewRtilCode: this.rtilCode
        }
      };
      item.visible = false;
      this.axios.post('/partyline-backend/party/noLogin/command?key=32899', parmas).then(res => {
        if (res.data.errorCode === '0x0') {
          this.privateStream = {};
          this.setLoading = false;
          this.$message({
            type: 'success',
            message: 'Cancel private conversation success'
          });
        }
      });
    },
    cancelQuestionSpeaker() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'cancelQuestionSpeaker',
        msg: {
          nickName: this.State.talkInfo.nickName,
          rtilCode: this.State.talkInfo.rtilCode
        }
      };
      this.visible = false;
      this.axios.post('/partyline-backend/party/noLogin/command?key=99235', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.State.talkInfo = null;
        }
      });
    },
    cancelQuestionerTalk(callbackInfo) {
      const params = {
        partyCode: this.State.partyCode,
        module: callbackInfo.type,
        msg: {
          nickName: callbackInfo.nickName,
          rtilCode: callbackInfo.id,
          showStartButton: true
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=81116', params);
    },
    setReplaceQuestionSpeaker() {
      const params = {
        partyCode: this.partyCode,
        module: 'setQuestionSpeaker',
        msg: {
          nickName: this.replaceInfo.nickName,
          rtilCode: this.replaceInfo.rtilCode,
          index: this.replaceInfo.index,
          notNeedDelete: true
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=51219', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.replaceInfo = null;
          this.$message({
            type: 'success',
            message: 'Switch successfully'
          });
        }
      });
    },
    changeHandList(pageNum) {
      this.sendRaiseHandParams.pageNum = pageNum;
      this.getRaiseHandList();
    }
  },
  beforeDestroy() {
    if (this.rtc) {
      this.rtc.leave(this.hadOpenWebCloud ? 'closeCLoudProxy' : '');
    }
    this.rtc = null;
    this.userInfo = {};
    this.socket && this.socket.close();
    this.State.pageSerBusRequestWs[this.partyCode] && this.State.pageSerBusRequestWs[this.partyCode].close();
    if (this.wsPageSTimer) clearInterval(this.wsPageSTimer);
    if (this.sendMetadataTimer) clearInterval(this.sendMetadataTimer);
  }
};